// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import MembershipDocumentListModel from '../../model/membership-document-list-model';
import MembershipDocumentListDTO from '../dto/membership-document-list-dto';
import dtoSchema from '../schemas/membership-document-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class MembershipDocumentListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<MembershipDocumentListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.subject = data.subject ?? undefined;
      this.documentType = data.documentType ?? undefined;
      this.fileExtension = data.fileExtension ?? undefined;
      this.downloadUrl = data.downloadUrl ?? undefined;
      this.createdOn = data.createdOn ?? undefined;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  subject?: string;
  /**
  */
  documentType?: string;
  /**
  */
  fileExtension?: string;
  /**
  */
  downloadUrl?: string;
  /**
  * @type {date-time}
  */
  createdOn?: string;

  static toModel(dto: DeepPartial<MembershipDocumentListDTO>): MembershipDocumentListModel;
  static toModel(dto: DeepPartial<MembershipDocumentListDTO> | undefined | null): MembershipDocumentListModel | undefined;
  static toModel(dto: DeepPartial<MembershipDocumentListDTO> | undefined | null): MembershipDocumentListModel | undefined {
    return dto ? new MembershipDocumentListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<MembershipDocumentListModel> | MembershipDocumentListModel): MembershipDocumentListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      subject: unwrapped.subject,
      documentType: unwrapped.documentType,
      fileExtension: unwrapped.fileExtension,
      downloadUrl: unwrapped.downloadUrl,
      createdOn: unwrapped.createdOn,
    } as MembershipDocumentListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for MembershipDocumentListModel, can not map to MembershipDocumentListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
